import styled, { css } from 'vue3-styled-components';

export const ClientGetDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    max-width: 1200px;
    width: 100%;
`;

export const ClientGetTitleArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-weight: bold;
    font-size: 28px;
    margin-bottom: 24px;
    gap: 12px;
    color: #1f2937;
`;

export const TitleText = styled.span`
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
`;

export const SearchAndStatsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 24px 0;
    gap: 24px;
`;

export const ClientGetSearchArea = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const ClientGetSearchInputTxt = styled.input`
    width: 200px;
    height: 44px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: #f9fafb;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(251, 139, 36, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`;

export const ClientGetSearchBtn = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const ClientRegisterBtn = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 12px;
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 16px;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const ClientTypeSelect = styled.select`
    width: 100px;
    height: 44px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: #f9fafb;
    cursor: pointer;
    font-weight: 500;
    color: #374151;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(251, 139, 36, 0.1);
    }

    &:hover {
        border-color: #0f4c5c;
        background: #ffffff;
    }

    option {
        background: #ffffff;
        color: #374151;
        padding: 8px;
    }
`;

export const StatsBox = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
`;

export const StatItem = styled.div`
    background: linear-gradient(135deg, #fb8b24 0%, #ea580c 100%);
    border-radius: 16px;
    padding: 16px 24px;
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.2);
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: white;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(251, 139, 36, 0.3);
    }
`;

export const StatLabel = styled.span`
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    font-weight: 500;
    margin-right: 8px;
`;

export const StatValue = styled.span`
    color: white;
    font-size: 18px;
    font-weight: 700;
`;

export const ClientGetTableContainer = styled.div`
    width: 100%;
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
`;

export const ClientGetTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
`;

export const ClientGetTableThead = styled.thead`
    background: linear-gradient(135deg, #fb8b24 0%, #ea580c 100%);
    color: white;
`;

export const ClientGetTableTbody = styled.tbody`
    max-height: 500px;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #fb8b24;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #ea580c;
    }
`;

export const ClientGetTableTr = styled.tr`
    font-size: 14px;
    border-bottom: 1px solid #f3f4f6;

    th {
        padding: 16px 8px;
        text-align: center;
        font-weight: 600;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: white;
        background: transparent;
        position: sticky;
        top: 0;
        z-index: 10;
    }

    td {
        padding: 16px 8px;
        text-align: center;
        vertical-align: middle;
        color: #374151;
        font-weight: 500;
        word-wrap: break-word;
        overflow: hidden;
    }

    &.client_tr {
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            background: #fef3c7;
            transform: scale(1.01);
            box-shadow: 0 4px 12px rgba(251, 139, 36, 0.1);
        }

        &:active {
            transform: scale(1);
        }
    }

    // 컬럼별 너비 설정
    th:nth-child(1), td:nth-child(1) { width: 12%; } // 수급자성함
    th:nth-child(2), td:nth-child(2) { width: 12%; } // 인정번호
    th:nth-child(3), td:nth-child(3) { width: 10%; } // 생년월일
    th:nth-child(4), td:nth-child(4) { width: 8%; }  // 대상
    th:nth-child(5), td:nth-child(5) { width: 25%; } // 주소
    th:nth-child(6), td:nth-child(6) { width: 12%; } // 보호자성함
    th:nth-child(7), td:nth-child(7) { width: 8%; }  // 관계
    th:nth-child(8), td:nth-child(8) { width: 13%; } // 담당자

    &.success {
        border-left: 4px solid #22c55e;
    }

    &.warning {
        border-left: 4px solid #f59e0b;
    }

    &.info {
        border-left: 4px solid #3b82f6;
    }

    &.danger {
        border-left: 4px solid #ef4444;
    }
`;

export const TargetBadge = styled.span`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    ${props => {
        switch (props.target) {
            case '일반':
                return css`
                    background: #dcfce7;
                    color: #166534;
                `;
            case '기초':
                return css`
                    background: #fecaca;
                    color: #991b1b;
                `;
            case '의료급여':
                return css`
                    background: #dbeafe;
                    color: #1e40af;
                `;
            case '감경':
                return css`
                    background: #fef3c7;
                    color: #92400e;
                `;
            default:
                return css`
                    background: #f1f5f9;
                    color: #475569;
                `;
        }
    }}
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 0;
    margin-top: 16px;
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    padding: 8px;
    border-radius: 12px;
`;

export const PaginationButton = styled.button`
    padding: 6px 10px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #6b7280;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
        transform: translateY(-1px);
    }
    
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        transform: none;
    }
`;

const paginationNumberProps = css`
    ${props => props.active && css`
        background: #fb8b24;
        color: white;
        border-color: #fb8b24;
        transform: scale(1.1);
    `}
`;

export const PaginationNumber = styled.button`
    min-width: 40px;
    height: 40px;
    padding: 0 12px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #6b7280;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;
    white-space: nowrap;
    ${paginationNumberProps}
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
        transform: translateY(-1px);
    }
`;